import { useEffect } from "react";
import About from "@/components/sections/About";

export default function AboutPage() {
  useEffect(() => { document.title = "About — Warranty_Vault pro"; }, []);
  return (
    <main className="pt-16" data-testid="about-page">
      <About />
    </main>
  );
}
